module.exports = __webpack_public_path__ + "static/media/warning.d5fc3b85.svg";